module.exports = __webpack_public_path__ + "static/media/import_usevote.b1588270.xlsx";